import { storeToRefs } from 'pinia';
import { defineNuxtRouteMiddleware, navigateTo } from '#app/composables/router';
import { useAuth } from '#layers/access/public';
import { resolveBackdropWorkspaceSlug } from '#layers/workspace/public';

/**
 * Recovers a user straight into an available workspace: memberships can change while the
 * no-workspace page is open, so each load re-resolves them. Resolving here — rather than via
 * `navigateTo` inside the page `setup()` — settles the redirect before the page mounts and does not
 * race the initial hydration navigation. With no workspace, it falls through and the page renders.
 */
export default defineNuxtRouteMiddleware(async () => {
	const { currentUser } = storeToRefs(useAuth());
	const slug = await resolveBackdropWorkspaceSlug(currentUser.value?.id);

	if (slug) {
		return navigateTo({ name: 'workspace-home', params: { workspace: slug } }, { replace: true });
	}
});
